import React from "react";
import PropTypes from "prop-types";
import { Dialog } from '@mui/material';
import { testAttributes } from './Constants';
import { modalWrapper, closeButton, dialogWrapper, mainContent } from './Modal.module.scss';
import closeIcon from '../../../static_assets/icons/close.svg';

const Modal = ({content, isOpen, handleClose}) => (
    <Dialog
        onClose={handleClose}
        aria-labelledby="modal"
        open={isOpen}
        data-testid={testAttributes.MODAL_CONTAINER}
        className={dialogWrapper}
        maxWidth='md'
    >
        <div className={modalWrapper} data-testid={testAttributes.MODAL_CONTENT_WRAPPER}>
            <div className={mainContent} data-testid={testAttributes.MODAL_CONTENT}>
                {content}
            </div>
            <img
                src={closeIcon}
                className={closeButton}
                data-testid={testAttributes.CLOSE_ICON}
                onClick={handleClose}
                onKeyDown={handleClose}
                role="presentation"
                alt="close"
            />
        </div>
    </Dialog>
);

Modal.propTypes = {
    /** Modal content. Array of JSX expected */
    content: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.object,
        PropTypes.string,
    ]).isRequired,
    /** Attribute of Modal; Define when the modal is show (true) or hide (false) */
    isOpen: PropTypes.bool.isRequired,
    /** Event of Modal ; Fire after the modal is closed */
    handleClose: PropTypes.func.isRequired,
};

export default Modal;